import MagazineTeaserArticle from '@uikit/components/Magazine/MagazineTeaserArticle/MagazineTeaserArticle';
import type { MagazineTeaserArticleWrapperProps } from './interfaces';

const MagazineTeaserArticleWrapper = ({
  article,
  align,
  variant,
}: MagazineTeaserArticleWrapperProps) => {
  const props = {
    align,
    variant,
    ...article,
  };

  return <MagazineTeaserArticle {...props} />;
};

export default MagazineTeaserArticleWrapper;
